/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Appointment } from './Appointment';
import {
    AppointmentFromJSON,
    AppointmentFromJSONTyped,
    AppointmentToJSON,
} from './Appointment';
import type { TaskComment } from './TaskComment';
import {
    TaskCommentFromJSON,
    TaskCommentFromJSONTyped,
    TaskCommentToJSON,
} from './TaskComment';

/**
 * 
 * @export
 * @interface PatientListItem
 */
export interface PatientListItem {
    /**
     * 
     * @type {string}
     * @memberof PatientListItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientListItem
     */
    patient_id: string;
    /**
     * 
     * @type {number}
     * @memberof PatientListItem
     */
    date?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientListItem
     */
    information?: string;
    /**
     * 
     * @type {Appointment}
     * @memberof PatientListItem
     */
    appointment?: Appointment;
    /**
     * 
     * @type {Array<TaskComment>}
     * @memberof PatientListItem
     */
    comments?: Array<TaskComment>;
}

/**
 * Check if a given object implements the PatientListItem interface.
 */
export function instanceOfPatientListItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "patient_id" in value;

    return isInstance;
}

export function PatientListItemFromJSON(json: any): PatientListItem {
    return PatientListItemFromJSONTyped(json, false);
}

export function PatientListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'patient_id': json['patient_id'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'information': !exists(json, 'information') ? undefined : json['information'],
        'appointment': !exists(json, 'appointment') ? undefined : AppointmentFromJSON(json['appointment']),
        'comments': !exists(json, 'comments') ? undefined : ((json['comments'] as Array<any>).map(TaskCommentFromJSON)),
    };
}

export function PatientListItemToJSON(value?: PatientListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'patient_id': value.patient_id,
        'date': value.date,
        'information': value.information,
        'appointment': AppointmentToJSON(value.appointment),
        'comments': value.comments === undefined ? undefined : ((value.comments as Array<any>).map(TaskCommentToJSON)),
    };
}

